import React from 'react';
import { Quote, Star } from 'lucide-react';
import { Card } from './ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "MILAMIA transformed our entire digital presence. Within 3 months, our e-commerce revenue increased by 180%. Their AI-driven approach to branding is truly revolutionary.",
      role: "E-Commerce Business Owner",
      location: "Miami, Florida",
      rating: 5
    },
    {
      quote: "Profesyonel ekip, hızlı teslimat ve mükemmel sonuçlar. Logo tasarımından web sitesine kadar her şeyi tek çatı altında çözdük. Kesinlikle tavsiye ediyorum.",
      role: "Startup Kurucusu",
      location: "İstanbul, Türkiye",
      rating: 5
    },
    {
      quote: "The brand identity they created for us perfectly captures our vision. Our customers constantly compliment our new look. Best investment we've made for our business.",
      role: "Restaurant Chain Owner",
      location: "Fort Lauderdale, Florida",
      rating: 5
    },
    {
      quote: "Dijital dönüşüm sürecimizde MILAMIA ile çalışmak büyük avantaj sağladı. AI destekli çözümleri sayesinde operasyonel verimliliğimiz %40 arttı.",
      role: "İmalat Şirketi Yöneticisi",
      location: "Ankara, Türkiye",
      rating: 5
    },
    {
      quote: "From concept to execution, they delivered beyond expectations. Their understanding of both US and international markets gave us a competitive edge.",
      role: "Import/Export Business Owner",
      location: "Miami, Florida",
      rating: 5
    },
    {
      quote: "E-ticaret sitemizi sıfırdan kurdular ve satışlarımız ilk ayda 3 katına çıktı. Teknik destek ve danışmanlık hizmetleri de çok değerli.",
      role: "Online Mağaza Sahibi",
      location: "Bursa, Türkiye",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <span className="section-label">Testimonials</span>
          <h2 className="section-title">What Our Clients Say</h2>
          <p className="section-description">
            Hear from businesses we've helped transform across the United States and Turkey.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="testimonial-card">
              <div className="testimonial-quote-icon">
                <Quote size={32} />
              </div>
              
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} className="star-icon" fill="currentColor" />
                ))}
              </div>

              <p className="testimonial-text">"{testimonial.quote}"</p>
              
              <div className="testimonial-author">
                <p className="testimonial-role">{testimonial.role}</p>
                <p className="testimonial-location">{testimonial.location}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
